// import { AccountNotif, MemberNotif } from '../../../components/SvgIcons';
import { TitleText, TimeText } from "./styled";
import React, { FC, useCallback } from "react";
import { formatDateString } from "../utils";
import { useHistory } from "react-router-dom";
import Flex from "../../../components/flex";
import { NotificationInterface } from "./interface";

const OneNotification: FC<NotificationInterface> = ({
  Title,
  time,
  fullObject,
  onClick,
}): JSX.Element => {
  const { push } = useHistory();
  // const handleDate = React.useCallback(() => {
  //     let CurrentDate = Date.now();
  //     let DifDates = CurrentDate-time.getDate();
  // } , [time])

  return (
    <Flex
      padding="12px 16px"
      margin="0"
      radius="0"
      column
      width="100%"
      cursor="pointer"
      onClick={() => onClick(fullObject)}
      background={fullObject?.isRead ? "#fff" : "#EFF6FF"}
      style={{ borderBottom: "1px solid #F3F4F6" }}
    >
      {console.log(fullObject, "full")}
      <Flex>
        <Flex column width="100%">
          <TitleText children={Title} />
          <Flex width="100%" padding=" 0 15px 0 0 ">
            <TimeText children={formatDateString(time + "")} />
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default React.memo(OneNotification);
